// It's called index.js because, by convention, an index.js file in a folder acts
// as the main entry point for that folder/module. When you import from the folder
// (e.g., import GAME_COMPONENTS from "../games"), Node.js and most bundlers will
// automatically resolve to index.js inside that folder.

// Central mapping of all game components for use throughout the app
import TicTacToeGame from "../games/TicTacToeGame";
import NumberGuessGame from "../games/NumberGuessGame";
import MathsQuizGame from "../games/MathsQuizGame";
import WhirdleGame from "../games/WhirdleGame";
import SnakeGame from "../games/SnakeGame";
import MatchPairsGame from "../games/MatchPairsGame";
import SnapGame from "../games/SnapGame";
import NertzGame from "../games/NertzGame";
import HangmanGame from "../games/HangmanGame";
import YouTubeGame from "../games/YouTubeGame";
import FourInARowGame from "../games/FourInARowGame";
import WanGame from "./WanGame";
import RollFiveGame from "./RollFiveGame";
import GoFishGame from "./GoFishGame";
import DominoesGame from "./DominoesGame";
import ChessGame from "../games/ChessGame";
import DraughtsGame from "../games/DraughtsGame";
import PokerGame from "./PokerGame";
import WhirdleHashGame from "../games/WhirdleHashGame";
import GuessTheSongGame from "./GuessTheSongGame";
import LetterLinkGame from "./LetterLinkGame";
import DecksOfDepravityGame  from "./DecksOfDepravityGame";
import CanvasCrazeGame from "./CanvasCrazeGame";
import CharadesGame from "./CharadesGame";
import OneWordStoryGame from "./OneWordStoryGame";
import TimeTapGame from "./TimeTapGame";
import MostLikelyGame from "./MostLikelyGame";
import SinkingShipsGame from "./SinkingShipsGame";
import StatClashGame from "./StatClashGame";
import BingoGame from "./BingoGame";
import BoxesGame from "./BoxesGame";
import RockPaperScissorsGame from "./RockPaperScissorsGame";
import WordSearchGame from "./WordSearchGame";
import RepeatAfterMeGame from "./RepeatAfterMeGame";
import RedLightGreenLightGame from "./RedLightGreenLightGame";
import QuizGame from "./QuizGame";
import SequenceMasterGame from "./SequenceMasterGame";
import SetSquareGame from "./SetSquareGame";
import CrosswordGame from "./CrosswordGame";
import UnscrambleGame from "./UnscrambleGame";
import WordLadderGame from "./WordLadderGame";
import WhoAmIGame from "./WhoAmIGame";
import DartsGame from "./DartsGame";
import KnockoutGame from "./KnockoutGame";
import MentalMathsGame from "./MentalMathsGame";
import RebusGame from "./RebusGame";
import TruthOrDareGame from "./TruthOrDareGame";
import NeverHaveIEverGame from "./NeverHaveIEverGame";
import WhereAmIGame from "./WhereAmIGame";
import MusicTheoryQuizGame from "./MusicTheoryQuizGame";
import WouldYouRatherGame from "./WouldYouRatherGame";
import CanastaGame from "./CanastaGame";
import GoGame from "./GoGame";
import SnakesAndLaddersGame from "./SnakesAndLaddersGame";
import SlidingTilesGame from "./SlidingTilesGame";
import SurveySaysGame from "./SurveySaysGame";
import SudokuGame from "./SudokuGame";
import BackgammonGame from "./BackgammonGame";
import WheelOfDestinyGame from "./WheelOfDestinyGame";
import EyeForDetailGame from "./EyeForDetailGame";
import SolitaireGame from "./SolitaireGame";
import MinesweeperGame from "./MinesweeperGame";
import TrianglesGame from "./TrianglesGame";
import FaceFinderGame from "./FaceFinderGame";
import SlotCarsGame from "./SlotCarsGame";
import CurlingGame from "./CurlingGame";
import UltimateTicTacToeGame from "./UltimateTicTacToeGame";
import Game2048 from "./2048Game";
import ColorMixGame from "./ColorMixGame";
import MatchMakerGame from "./MatchMakerGame";
import VideoChatGame from "./VideoChatGame";
import TagGame from "./TagGame";
import ShapeShifterGame from "./ShapeShifterGame";
import ClosestGuessGame from "./ClosestGuessGame";
import SpotTheBallGame from "./SpotTheBallGame";
import TerritoryGame from "./TerritoryGame";
import ImpulseTraderGame from "./ImpulseTraderGame";
import LocationTrackerGame from "./LocationTrackerGame";

const GAME_COMPONENTS = {
  TicTacToe: TicTacToeGame,
  NumberGuess: NumberGuessGame,
  MathsQuiz: MathsQuizGame,
  Whirdle: WhirdleGame,
  Snake: SnakeGame,
  MatchPairs: MatchPairsGame,
  Snap: SnapGame,
  Nertz: NertzGame,
  Hangman: HangmanGame,
  YouTube: YouTubeGame,
  FourInARow: FourInARowGame,
  Wan: WanGame,
  RollFive: RollFiveGame,
  GoFish: GoFishGame,
  Dominoes: DominoesGame,
  Poker: PokerGame,
  Chess: ChessGame,
  Draughts: DraughtsGame,
  WhirdleHash: WhirdleHashGame,
  GuessTheSong: GuessTheSongGame,
  LetterLink: LetterLinkGame,
  DecksOfDepravity: DecksOfDepravityGame,
  CanvasCraze: CanvasCrazeGame,
  Charades: CharadesGame,
  TimeTap: TimeTapGame,
  OneWordStory: OneWordStoryGame,
  MostLikely: MostLikelyGame,
  SinkingShips: SinkingShipsGame,
  StatClash: StatClashGame,
  Bingo: BingoGame,
  Boxes: BoxesGame,
  RockPaperScissors: RockPaperScissorsGame,
  WordSearch: WordSearchGame
  ,RepeatAfterMe: RepeatAfterMeGame
  ,RedLightGreenLight: RedLightGreenLightGame
  ,Quiz: QuizGame
  ,SequenceMaster: SequenceMasterGame
  ,SetSquare: SetSquareGame
  ,Crossword: CrosswordGame
  ,Unscramble: UnscrambleGame
  ,WordLadder: WordLadderGame
  ,WhoAmI: WhoAmIGame
  ,Darts: DartsGame
  ,Knockout: KnockoutGame
  ,MentalMaths: MentalMathsGame
  ,Rebus: RebusGame
  ,TruthOrDare: TruthOrDareGame
  ,NeverHaveIEver: NeverHaveIEverGame
  ,WhereAmI: WhereAmIGame
  ,MusicTheoryQuiz: MusicTheoryQuizGame
  ,WouldYouRather: WouldYouRatherGame
  ,Canasta: CanastaGame
  ,Go: GoGame
  ,SnakesAndLadders: SnakesAndLaddersGame
  ,SlidingTiles: SlidingTilesGame
  ,SurveySays: SurveySaysGame
  ,Sudoku: SudokuGame
  ,Backgammon: BackgammonGame
  ,WheelOfDestiny: WheelOfDestinyGame
  ,EyeForDetail: EyeForDetailGame
  ,Solitaire: SolitaireGame
  ,Minesweeper: MinesweeperGame
  ,Triangles: TrianglesGame
  ,FaceFinder: FaceFinderGame
  ,SlotCars: SlotCarsGame
  ,Curling: CurlingGame
  ,UltimateTicTacToe: UltimateTicTacToeGame
  ,'Game2048': Game2048
  ,ColorMix: ColorMixGame
  ,MatchMaker: MatchMakerGame
  ,VideoChat: VideoChatGame
  ,Tag: TagGame
  ,ShapeShifter: ShapeShifterGame
  ,ClosestGuess: ClosestGuessGame
  ,SpotTheBall: SpotTheBallGame
  ,Territory: TerritoryGame
  ,ImpulseTrader: ImpulseTraderGame
  ,LocationTracker: LocationTrackerGame
};

export default GAME_COMPONENTS;
